import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-big-message',
  templateUrl: './content-big-message.component.html',
  styleUrls: ['./content-big-message.component.scss']
})
export class ContentBigMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
